// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".all-radius[data-v-702820c9]{border-radius:1rem !important}.no-radius[data-v-702820c9]{border-radius:0 !important}.top-radius[data-v-702820c9]{border-radius:0 0 1rem 1rem !important}.cancelbtn[data-v-702820c9]{border-color:var(--v-primary-base);color:var(--v-primary-base)}.info-text[data-v-702820c9]{font-size:10px}.info-text .info-icon[data-v-702820c9]{font-size:13px}.whitespace-normal[data-v-702820c9]{white-space:normal}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
